<template>

  <!-- Edit Schedule Modal -->
  <div id="add_schedule" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" v-if="isAddMode">Add Schedule Template</h5>
          <h5 class="modal-title" v-if="isEditMode">Edit Schedule Template</h5>
          <h5 class="modal-title" v-if="isViewMode">Schedule Template</h5>
          <button type="button" ref="Close" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="addSchedule()">
            <!-- <label class="col-form-label">Start Time <span class="text-danger">*</span></label> -->
            <!-- <v-text-field v-model="scheduleTemplateName" outlined :disabled="isViewMode"
                style="width:400px; margin:10px;" :rules="textValidation" label="Schedule template name"></v-text-field> -->
            <div class="row">
              <div class="col-sm-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">Template Name <span class="text-danger">*</span></label>
                  <input class="form-control" name="scheduleTemplateName" v-model="scheduleTemplateName"
                    placeholder="Schedule Name" :disabled="isViewMode" type="text" required />
                </div>
              </div>
              <div class="col-sm-6" v-if="isEditMode">
                <div class="input-block mb-3">
                  <label class="col-form-label">Effective Date <span class="text-danger">*</span></label>
                  <div class="cal-icon">
                    <date-picker
                      v-model="effectiveDate"
                      placeholder="Choose Date"
                      class="form-control floating datetimepicker"
                      :editable="true"
                      :clearable="false"
                      :input-format="dateFormat"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">Role</label>
                  <!-- <vue-select v-model="company_role_id" :options="companyId" :disabled="isViewMode"
                    placeholder="Select Role" name="company_role_id" id="company_role_id"
                    @select="select_role($event)" /> -->
                  <v-autocomplete v-model="company_role_id" :items="companyId" item-title="name" item-value="id"
                    :disabled="isViewMode" placeholder="select role" multiple chips closable-chips variant="outlined"
                    density="comfortable">
                  </v-autocomplete>
                </div>
              </div>
              <div class="col-md-6">
                <div class="input-block mb-3">
                  <label class="col-form-label">User</label>
                  <!-- <vue-select v-model="userId" :options="userData" :disabled="isViewMode"
                    placeholder="Select User" name="userId" id="userId"
                    @select="select_user($event)" /> -->
                  <v-autocomplete v-model="userId" :items="userData" item-title="name" item-value="id" :disabled="isViewMode"
                    placeholder="select Users" multiple chips closable-chips return-object variant="outlined"
                    density="comfortable">
                  </v-autocomplete>
                </div>
              </div>
            </div>
            <div v-for="(item, index) in scheduleTemplate" :key="index" class="my-2">
              <h3 class="mb-2">{{ item.weekday }}</h3>

              <div class="row">
                <div class="col-sm-5">
                  <div class="d-flex justify-content-between align-item-center">
                    <p>Shift</p>

                    <span @click="addShiftClicked(index)" v-if="!isViewMode"><i class="fas fa-plus"></i> Add</span>
                  </div>
                  <div class="row  mt-1 " v-for="(input, k) in item.shifts" :key="k">

                    <div class="col-sm-5">
                      <div class="input-block mb-3">
                        <label class="col-form-label">Start Time <span class="text-danger">*</span></label>
                        <div class="input-group time">
                          <input type="text" maxlength="8" @keydown="handleTimeKeydown($event, input, 'from_time')" v-model="input.from_time" class="form-control timepicker" placeholder="00:00:00" />

                        </div>
                      </div>
                    </div>


                    <div class="col-sm-5">
                      <div class="input-block mb-3">
                        <label class="col-form-label">End Time <span class="text-danger">*</span></label>
                        <div class="input-group time">
                          <input type="text" maxlength="8" @keydown="handleTimeKeydown($event, input, 'to_time')" v-model="input.to_time" class="form-control timepicker" placeholder="00:00:00" />

                        </div>
                      </div>
                    </div>
                    <div class="col-sm-2 top-margin text-center" v-if="!isViewMode"><span
                        @click="removeShiftClicked(index, k)"><i class="fas fa-trash"></i></span></div>

                  </div>
                </div>

                <div class="col-sm-5">
                  <div class="d-flex justify-content-between align-item-center">
                    <p>Break</p>
                    <span @click="addConditionClicked(index)" v-if="!isViewMode"><i class="fas fa-plus"></i> Add</span>
                  </div>
                  <div class="row  mt-1" v-for="(input, k) in item.conditions" :key="k">

                    <div class="col-sm-5">
                      <div class="input-block mb-3">
                        <label class="col-form-label">Work Hours<span class="text-danger">*</span></label>
                        <input type="text" maxlength="8" @keydown="handleTimeKeydown($event, input, 'work_hours')" v-model="input.work_hours" class="form-control timepicker" placeholder="00:00:00" />
                      </div>
                    </div>
                    <div class="col-sm-5">
                      <div class="input-block mb-3">
                        <label class="col-form-label">Break<span class="text-danger">*</span></label>
                        <input type="text" maxlength="8" @keydown="handleTimeKeydown($event, input, 'break_hours')" v-model="input.break_hours" class="form-control timepicker" placeholder="00:00:00" />
                      </div>
                    </div>
                    <div class="col-sm-2 top-margin text-center" v-if="!isViewMode"><span
                        @click="removeConditionClicked(index, k)"><i class="fas fa-trash"></i></span></div>
                  </div>
                </div>
                <div class="col-sm-2">
                  <div>
                    <div class="mb-3">
                      <div class="d-flex align-items-center">
                        <div class="form-check form-switch">
                          <input type="checkbox" class="form-check-input" :disabled="isViewMode"
                            v-model="item.is_working" id="customSwitch4" />
                          <label class="form-check-label" for="customSwitch4"></label>
                          <!-- v-model="Shift.is_working" :value="Shift.is_working" -->
                        </div><label class="col-form-label mt-1">Working Day</label>
                      </div>
                    </div>
                  </div>

                  <div class="mt-5" v-if="!isViewMode">
                    <div class="d-flex justify-content-between">
                      <a href="javascript:;" class="btn btn-light w-100 me-2"
                        @click="copyScheduleClicked(item)">Copy</a>
                      <a href="javascript:;" class="btn btn-light w-100" @click="pasteScheduleClicked(index)">Paste</a>
                    </div>

                  </div>
                </div>
              </div>
            </div>


            <div class="submit-section" v-if="!isViewMode">
              <button type="submit" class="btn btn-primary submit-btn">
                <span v-if="!isLoading">Submit</span>
                <div class="spinner-border spinner-border-sm text-light" role="status" v-else>
                  <span class="visually-hidden">Loading...</span>
                </div>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!-- /Edit Schedule Modal -->
</template>

<script>
import { timeInputMixin } from "../../mixins/timeInputMixin";
import { ref } from "vue";
import axios from 'axios';
import moment from "moment";
import {VUE_APP_API_BASE_URL} from "../../config";
const currentDate = ref(new Date());
const currentDateOne = ref(new Date());
export default {
  mixins: [timeInputMixin],
  data() {
    return {
      effectiveDate: new Date(),
      isLoading: false,
      userData: [],
      userId: [],
      scheduleId: '',
      scheduleTemplateName: '',
      user_schedule_data_id: '',
      loader: false,
      isAddMode: false,
      isEditMode: false,
      isViewMode: false,
      company_role_id: null,
      companyId: [],
      DAY_OF_WEEK: {
        SUNDAY: 0,
        MONDAY: 1,
        TUESDAY: 2,
        WEDNESDAY: 3,
        THURSDAY: 4,
        FRIDAY: 5,
        SATURDAY: 6,
      },
      scheduleTemplate: [
        {
          weekday: "Monday",
          is_working: '',
          conditions: [],
          shifts: []
        },
        {
          weekday: "Tuesday",
          is_working: '',
          conditions: [],
          shifts: [],
        },
        {
          weekday: "Wednesday",
          is_working: '',
          conditions: [],
          shifts: []
        },
        {
          weekday: "Thursday",
          is_working: '',
          conditions: [],
          shifts: []
        },
        {
          weekday: "Friday",
          is_working: '',
          conditions: [],
          shifts: []
        },
        {
          weekday: "Saturday",
          is_working: '',
          conditions: [],
          shifts: []
        },
        {
          weekday: "Sunday",
          is_working: '',
          conditions: [],
          shifts: []
        },
      ],
      startdate: currentDate,
      dateFormat: 'dd-MM-yyyy',
      startdateone: currentDateOne,
      RepeatOne: ["1", "2", "3", "4", "5", "6"],
      company_role_user_id: [
        {
          "company_role_id": ""
        },
        {
          "assigned_user_id": ""
        }
      ],
    };
  },
  mounted() {
    this.getCompanyRoles(),
      this.getUsersData()
  },
  methods: {
    show() {
      this.isAddMode = true;
      this.isEditMode = false;
      this.isViewMode = false;

      this.initScheduleTemplate();
    },
    showView(templateId) {
      this.isAddMode = false;
      this.isEditMode = false;
      this.isViewMode = true;

      this.initScheduleTemplate();
      this.getScheduleTemplate(templateId);
      this.getTemplateAssignedRoles(templateId);
      this.getTemplateAssignedUsers(templateId)
    },
    editView(templateId) {
      this.isAddMode = false;
      this.isEditMode = true;
      this.isViewMode = false;

      this.initScheduleTemplate();
      this.getScheduleTemplate(templateId);
      this.getTemplateAssignedRoles(templateId);
      this.getTemplateAssignedUsers(templateId);
    },
    // select_role(event) {
    //   this.company_role_id = event.id;
    // },
    // select_user(event) {
    //   this.userId = event.id;
    // },
    async getCompanyRoles() {
      await axios.get(`${VUE_APP_API_BASE_URL}/company-role/get`)
        .then((response) => {
          if (response.data.status) {
            this.companyId = response.data.data
            this.companyId.forEach(element => {
              delete element['created_at'];
              delete element['updated_at'];
              // element['text'] = element['name'];
              // delete element['name'];
            });
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        });
    },

    async getTemplateAssignedRoles(templateId) {
      await axios.get(`${VUE_APP_API_BASE_URL}/schedule-template/${templateId}/assigned-roles`)
        .then((response) => {
          if (response.data.status) {
            this.company_role_id = response.data.data;
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        });
    },

    async getTemplateAssignedUsers(templateId) {
      await axios.get(`${VUE_APP_API_BASE_URL}/schedule-template/${templateId}/assigned-users`)
        .then((response) => {
          if (response.data.status) {
            this.userId = response.data.data;
            this.userId.forEach(element => {
              element['name'] = element['first_name'] + ' ' + element['last_name'];
              delete element['first_name'];
              delete element['last_name'];
            },)

          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        });
    },



    async getUsersData() {
      await axios.get(`${VUE_APP_API_BASE_URL}/user/user-list`)
        .then((response) => {
          if (response.data.status) {
            this.userData = response.data.data
            this.userData.forEach(element => {
              element['name'] = element['first_name'] + ' ' + element['last_name'];
              delete element['first_name'];
              delete element['last_name'];
            });
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        });
    },
    removeShiftClicked(templateIndex, shiftIndex) {
      this.scheduleTemplate[templateIndex].shifts.splice(shiftIndex, 1);
    },
    removeConditionClicked(templateIndex, conditionIndex) {
      this.scheduleTemplate[templateIndex].conditions.splice(conditionIndex, 1);
    },
    initScheduleTemplate() {
      this.effectiveDate = new Date();
      this.scheduleTemplateName = "";
      this.company_role_id = [];
      this.userId = [];
      this.company_role_user_id = [
        {
          "company_role_id": ""
        },
        {
          "assigned_user_id": ""
        }
      ];
      this.scheduleTemplate = [
        {
          weekday: "Monday",
          is_working: false,
          conditions: [],
          shifts: []
        },
        {
          weekday: "Tuesday",
          is_working: false,
          conditions: [],
          shifts: [],
        },
        {
          weekday: "Wednesday",
          is_working: false,
          conditions: [],
          shifts: []
        },
        {
          weekday: "Thursday",
          is_working: false,
          conditions: [],
          shifts: []
        },
        {
          weekday: "Friday",
          is_working: false,
          conditions: [],
          shifts: []
        },
        {
          weekday: "Saturday",
          is_working: false,
          conditions: [],
          shifts: []
        },
        {
          weekday: "Sunday",
          is_working: false,
          conditions: [],
          shifts: []
        },
      ];
    },
    getScheduleTemplate(templateId) {
      var instance = this;
      instance.isLoading = true;


      axios.get(`${VUE_APP_API_BASE_URL}/schedule-template/${templateId}/show`)
        .then(function (response) {
          var scheduleTemplate = response.data.data;
          instance.scheduleId = scheduleTemplate.id;
          instance.scheduleTemplateName = scheduleTemplate.name;
          var scheduleDays = scheduleTemplate.schedule_days;
          scheduleDays.forEach((scheduleDay) => {
            var currentIndex = -1;
            if (scheduleDay.weekday == "Monday") {
              currentIndex = 0;
            } else if (scheduleDay.weekday == "Tuesday") {
              currentIndex = 1;
            } else if (scheduleDay.weekday == "Wednesday") {
              currentIndex = 2;
            } else if (scheduleDay.weekday == "Thursday") {
              currentIndex = 3;
            } else if (scheduleDay.weekday == "Friday") {
              currentIndex = 4;
            } else if (scheduleDay.weekday == "Saturday") {
              currentIndex = 5;
            } else if (scheduleDay.weekday == "Sunday") {
              currentIndex = 6;
            }

            instance.scheduleTemplate[currentIndex].is_working = scheduleDay.is_working === 1 ? true : false;

            var shifts_time = scheduleDay.schedule_template_shifts;

            shifts_time.forEach(element => {
              element.to_time = instance.formattedTime(element.to_time);
              element.from_time = instance.formattedTime(element.from_time);
            });

            instance.scheduleTemplate[currentIndex].shifts = shifts_time;

            var break_conditions = scheduleDay.schedule_template_break_conditions;

            break_conditions.forEach(element => {
              element.work_hours = instance.convertMinutesToHours(element.work_hours);
              element.break_hours = instance.convertMinutesToHours(element.break_hours);
            });
          

            instance.scheduleTemplate[currentIndex].conditions = break_conditions;


          });
          instance.dialog = true;
        })
        .catch((error) => {
          alert(error);
        })
        .then(() => {
          instance.isLoading = false;
        });
    },
    // convertMinutesToHours(minutes) {
    //   var num = minutes;
    //   var hours = (num / 60);
    //   var rhours = Math.floor(hours);
    //   var minute = (hours - rhours) * 60;
    //   var rminutes = Math.round(minute);
    //   return rhours + ":" + rminutes;
    // },
    convertMinutesToHours(minutes) {
        var hours = Math.floor(minutes / 60);
        var mins = minutes % 60;
        // Pad with leading zeros
        var paddedHours = hours.toString().padStart(2, '0');
        var paddedMinutes = mins.toString().padStart(2, '0');
        return `${paddedHours}:${paddedMinutes}`;
      },

    formattedTime(time) {
      return moment(time, 'HH:mm:ss').format('HH:mm');
    },

    copyScheduleClicked(item) {
      this.copiedTemplate = JSON.parse(JSON.stringify(item));
    },

    pasteScheduleClicked(index) {
      var copyTemplate = JSON.parse(JSON.stringify(this.copiedTemplate));
      this.scheduleTemplate[index].shifts = copyTemplate.shifts;
      this.scheduleTemplate[index].conditions = copyTemplate.conditions;
      this.scheduleTemplate[index].is_working = copyTemplate.is_working;
    },

    addShiftClicked(index) {
      var shift = {
        from_time: '',
        to_time: ''
      };
      this.scheduleTemplate[index].shifts.push(shift);
    },
    addConditionClicked(index) {
      var condition = {
        "work_hours": '',
        "break_hours": ''
      };
      this.scheduleTemplate[index].conditions.push(condition);
    },


    addSchedule() {
      this.loader = true;
      var ids = [];


      this.userId.forEach(element => {
        ids.push(element.id);
      });
      // this.userId = ids;
      let companyRoleUserInput = [
        { company_role_id: this.company_role_id },   // this could be a single value or array
        { assigned_user_id: ids }
      ];

      // Convert to desired output
      let formattedCompanyRoleUserId = [];

      // Handle company_role_id(s)
      if (Array.isArray(companyRoleUserInput[0].company_role_id)) {

        companyRoleUserInput[0].company_role_id.forEach(id => {
          if(id.id){
              formattedCompanyRoleUserId.push({ company_role_id: id.id });
          }else{
              formattedCompanyRoleUserId.push({ company_role_id: id });
          }
          
        });
      }

      // Handle assigned_user_id(s)
      if (Array.isArray(companyRoleUserInput[1].assigned_user_id)) {
        companyRoleUserInput[1].assigned_user_id.forEach(id => {
          formattedCompanyRoleUserId.push({ assigned_user_id: id });
        });
      }


      // Deep copy and format times to HH:MM before sending to the backend
      let formattedScheduleDays = JSON.parse(JSON.stringify(this.scheduleTemplate));
      formattedScheduleDays.forEach(day => {
        if (day.shifts && Array.isArray(day.shifts)) {
          day.shifts.forEach(s => {
            if (typeof s.from_time === 'string' && s.from_time.length > 5) {
              s.from_time = s.from_time.substring(0, 5);
            }
            if (typeof s.to_time === 'string' && s.to_time.length > 5) {
              s.to_time = s.to_time.substring(0, 5);
            }
          });
        }
        if (day.conditions && Array.isArray(day.conditions)) {
          day.conditions.forEach(c => {
            if (typeof c.work_hours === 'string' && c.work_hours.length > 5) {
              c.work_hours = c.work_hours.substring(0, 5);
            }
            if (typeof c.break_hours === 'string' && c.break_hours.length > 5) {
              c.break_hours = c.break_hours.substring(0, 5);
            }
          });
        }
      });

      var shift = {
        "template_name": this.scheduleTemplateName,
        "company_role_user_id": formattedCompanyRoleUserId,
        "schedule_days": formattedScheduleDays
      }

      var url = "/schedule-template/add";
      if (this.isEditMode) {
        url = `/schedule-template/${this.scheduleId}/update`;
        shift.effective_date = moment(this.effectiveDate).format('YYYY-MM-DD');
      }
      axios.post(`${VUE_APP_API_BASE_URL}${url}`, shift)
        .then((response) => {
          if (response.data.status) {
            this.$toast.success(response.data.message);
            this.$emit("editedShift");
            this.$refs.Close.click();
            this.loader = false;
          } else {
            this.$toast.error(response.data.message || response.data.errors);
            this.loader = false;
            // this.errorMessage = response.data.message ?? "";
          }
        })
        .finally(() => {
          this.loader = false;
        });

    }
  }
};
</script>

<style scoped>
.form-control {
  border-color: #bebec6 !important;
  border-radius: 4px;
  box-shadow: none;
  font-size: 14px;
  color: #4D5154;
  height: 49px !important;
  line-height: 2;
}

.top-margin {
  margin-top: 2.2rem !important;
}

.v-field__input {
  align-items: center;
  color: inherit;
  -moz-column-gap: 2px;
  column-gap: 2px;
  display: flex;
  flex-wrap: wrap;
  letter-spacing: 0.009375em;
  opacity: var(--v-high-emphasis-opacity);
  min-height: 0 !important;
  min-width: 0;
  /* padding-inline: var(--v-field-padding-start) var(--v-field-padding-end); */
  /* padding-top: var(--v-field-input-padding-top); */
  /* padding-bottom: var(--v-field-input-padding-bottom); */
  position: relative;
  width: 100%;
}
</style>
